import { Grid } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import React, { useEffect } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import * as config from "../../../config/config";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  ButtonContainer,
  ContactUsButton,
  GridContainerStyled,
  ImageStyled,
  RightContent,
  SliderBoldTitle,
  SliderDescription,
  TextContainer,
} from "./styles";

const FALLBACK_HERO_TITLE_HTML =
  "Job Posting & Headhunting | All In 1 Recruitment Site - Hiredly Malaysia";

function getStaticEmployerHeroJson() {
  const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
  return isMalaysia ? content_my : content_sg;
}

export default function EmployerHeroCarousel() {
  const staticJson = getStaticEmployerHeroJson();
  const heroCopy = {
    heroTitle: staticJson?.heroTitle ?? "",
    heroSubtitle: staticJson?.heroSubtitle ?? "",
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        // setHeight(getOriHeight());
        // setShowContainer(true);
      } else {
        // setHeight(getCollapseHeight());
        // setShowContainer(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const posthog = usePostHog();
  const buttonCTA = "Post Jobs Now";
  const buttonColour = "yellow";

  function triggerEmployerSignUp() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "hero",
    });
  }

  const heroTitleHtml =
    typeof heroCopy?.heroTitle === "string" && heroCopy.heroTitle.trim() !== ""
      ? heroCopy.heroTitle
      : FALLBACK_HERO_TITLE_HTML;

  const heroTitlePlain = heroTitleHtml
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return (
    <Grid id="hero-carousel">
      <GridContainerStyled>
        <ImageStyled
          src={
            config.assetDomain + "/images/employer_landing/elp-puzzle-img.png"
          }
          alt={heroTitlePlain || "Hiredly employer"}
        />

        <RightContent>
          <TextContainer>
            <SliderBoldTitle
              dangerouslySetInnerHTML={{ __html: heroTitleHtml }}
            />
            <SliderDescription>
              {heroCopy?.heroSubtitle ?? ""}
            </SliderDescription>
          </TextContainer>
          <ButtonContainer>
            <ContactUsButton
              variant="contained"
              onClick={() => triggerEmployerSignUp()}
            >
              {buttonCTA}
            </ContactUsButton>
          </ButtonContainer>
        </RightContent>
      </GridContainerStyled>
    </Grid>
  );
}
